import { campaignTelFortuneIds } from "features/campaigns/constants";

export const campaignCoupons = [
  {
    name: "電話占いが初回無料！？電話占い2000円分無料クーポン",
    catchCopy:
      "はじめての電話占いで利用できる2000円分無料クーポンがプレゼントされました！",
    description:
      "電話鑑定をご利用された事がないお客様限定で、0円~電話鑑定をお楽しみいただけるクーポンを配布させていただきました。",
    fortuneTellerIds: campaignTelFortuneIds,
  },
  {
    name: "電話占いが1回無料！？電話占い3000円分無料クーポン",
    catchCopy:
      "電話占いで利用できる3000円分無料クーポンがプレゼントされました！",
    description:
      "一部のお客様限定で、0円~電話鑑定をお楽しみいただけるクーポンを配布させていただきました。",
    fortuneTellerIds: campaignTelFortuneIds,
  },
];

export const thanksOrderCoupons = [
  {
    name: "鑑定通話終了3時間以内1000円OFFクーポン",
  },
  {
    name: "電話鑑定申込完了3時間以内1000円OFFクーポン",
  },
];

export const dailyBonusCoupons = [
  {
    name: "電話占い最大5分無料！デイリーボーナスクーポン",
  },
];
